export default __webpack_public_path__ + "static/kampagne-sparkasse-46f6e281927d1b70b72a40d64e2e0db4.jpg";